import { cva } from "class-variance-authority"

export const separatorVariants = cva("shrink-0", {
  variants: {
    orientation: {
      horizontal: "w-full",
      vertical: "h-full",
    },
    variant: {
      solid: "bg-neutral-200",
      dashed: "border-dashed border-neutral-200",
    },
  },
  compoundVariants: [
    { orientation: "horizontal", variant: "solid", class: "h-px" },
    { orientation: "vertical", variant: "solid", class: "w-px" },
    { orientation: "horizontal", variant: "dashed", class: "border-t" },
    { orientation: "vertical", variant: "dashed", class: "border-l" },
  ],
  defaultVariants: {
    orientation: "horizontal",
    variant: "solid",
  },
})
